module.exports = __webpack_public_path__ + "img/media_banner_btn.0ddf2ae9.png";